import { atom } from 'jotai';

export interface CallableValueType {
    name: string;
    value: any;
    line: number;
} 

export const callableValuesAtom = atom<CallableValueType[]>([]);